/**
 * deathRecordModel — pure helper for the Timeline's death-record event
 * rendering (FE-7). The three event kinds (`ADMISSION_DEATH_RECORDED` /
 * `ADMISSION_DEATH_UPDATED` / `ADMISSION_DEATH_REMOVED`, invariant 5) carry
 * server-side titles the Timeline renders straight off the row — NO FE
 * event-kind→label map (S6). Only `ADMISSION_DEATH_UPDATED` needs FE work:
 * its `refs.changes` (`[{field, old, new}]`) reuses the EXACT shape
 * `ADMISSION_INSURANCE_UPDATED` already ships (S7) — mirrored here the same
 * way `insuranceModel.js`'s `describeInsuranceEventChanges` renders its own
 * event, never a second diff shape.
 */

const FIELD_LABELS = {
  death_at: 'Date & time of death',
  declaring_doctor_member_id: 'Declaring doctor',
  declaring_doctor_name: 'Declaring doctor',
  immediate_cause: 'Immediate cause',
  antecedent_cause: 'Antecedent cause',
};

function formatDeathChangeValue(field, value) {
  if (value == null || value === '') return '—';
  if (field === 'death_at') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString();
  }
  return String(value);
}

/**
 * describeDeathRecordEventChanges — turns an `ADMISSION_DEATH_UPDATED`
 * event's `refs.changes` into short readable "Label: old → new" lines for
 * the Timeline. Returns `[]` when the event carries no changes
 * (contract-silent/absent `refs` never throws).
 */
export function describeDeathRecordEventChanges(event) {
  const changes = event && event.refs && event.refs.changes;
  if (!Array.isArray(changes)) return [];
  return changes.map((c) => {
    const label = FIELD_LABELS[c.field] || c.field;
    return `${label}: ${formatDeathChangeValue(c.field, c.old)} → ${formatDeathChangeValue(c.field, c.new)}`;
  });
}
